import Vue from 'vue';
import Quasar from 'quasar';
import { Notify } from 'quasar';
import langIt from 'quasar/lang/it';
import iconSet from 'quasar/icon-set/fontawesome-v5';

import acare_fe from '@advenias_developer/acare-fe';
import '@advenias_developer/acare-fe/dist/acare_fe.umd.min.css';

addCss('https://cdn-acare.e-personam.com/adv-quasar/v1.0.0/quasar.min.css');

Vue.prototype.$eventBus = window.eventBus;
Vue.prototype.config = window.config;
Vue.config.devtools = import.meta.env.MODE == 'development';

Vue.use(Quasar, {
  lang: langIt,
  plugins: { Notify },
  iconSet,
});

Vue.use(acare_fe);

function addCss(fileName) {
  let head = document.head;
  let link = document.createElement('link');
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = fileName;
  head.prepend(link);
}
